"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _file = _interopRequireDefault(require("@atlaskit/icon/core/file"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EditorFileIcon = props => /*#__PURE__*/_react.default.createElement(_base.UNSAFE_IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 6.5c0-.276.228-.5.491-.5H13l4 4v7.5c0 .276-.228.5-.51.5H7.51a.51.51 0 0 1-.51-.5zm5 1v2.999c0 .271.225.501.501.501H15.5z"/></svg>`
}, props, {
  newIcon: _file.default
}));
EditorFileIcon.displayName = 'EditorFileIcon';
var _default = exports.default = EditorFileIcon;